/* root.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./root.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useRef } from 'react';
import { SkipLinksContainer } from '../../components/skip-links/skip-links-container';
import { HomeActionsProvider } from '../../context/home-actions/home-actions-provider';
import { SkipLinksProvider } from '../../context/skip-links/skip-links-provider';
import { DangerouslyHoistSlotSizes } from './hoist-slot-sizes-context';
import { SideNavToggleButtonProvider } from './side-nav/toggle-button-provider';
import { SideNavVisibilityProvider } from './side-nav/visibility-provider';

// ID of the root element that the banner and top bar slots hoist their sizes to. Only internally exported.
export var gridRootId = 'unsafe-design-system-page-layout-root';
var styles = {
  root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};

/**
 * A root component of the navigation system. It wraps the undelying components with the necessary contexts allowing to use certain data and hooks
 * @param skipLinksLabel - The very first element of the layout is a skip links container that can be accessed by pressing Tab button and holds the links to the other sections of the layout thus improving accessibility. This parameter defines the header text for this container
 */
export function Root(_ref) {
  var children = _ref.children,
    xcss = _ref.xcss,
    _ref$UNSAFE_dangerous = _ref.UNSAFE_dangerouslyHoistSlotSizes,
    UNSAFE_dangerouslyHoistSlotSizes = _ref$UNSAFE_dangerous === void 0 ? false : _ref$UNSAFE_dangerous,
    _ref$skipLinksLabel = _ref.skipLinksLabel,
    skipLinksLabel = _ref$skipLinksLabel === void 0 ? 'Skip to:' : _ref$skipLinksLabel,
    testId = _ref.testId;
  var ref = useRef(null);
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      var IGNORED_ELEMENTS = ['SCRIPT', 'STYLE'];
      if (ref.current) {
        Array.from(ref.current.children).forEach(function (child) {
          if (!IGNORED_ELEMENTS.includes(child.tagName) && !child.hasAttribute('data-layout-slot')) {
            // eslint-disable-next-line no-console
            console.error("Page Layout Error\n\nThis element has been forcibly hidden:\n\n", child, "\n\nAn element was rendered as a child of the page layout root that isn't a page layout component! Resolve this error by moving it into a page layout component.\n\nThis message will not be displayed in production.\n");
          }
        });
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(SideNavVisibilityProvider, null, /*#__PURE__*/React.createElement(SideNavToggleButtonProvider, null, /*#__PURE__*/React.createElement(HomeActionsProvider, null, /*#__PURE__*/React.createElement(DangerouslyHoistSlotSizes.Provider, {
    value: UNSAFE_dangerouslyHoistSlotSizes
  }, /*#__PURE__*/React.createElement(SkipLinksProvider, null, /*#__PURE__*/React.createElement(SkipLinksContainer, {
    label: skipLinksLabel,
    testId: testId
  }), /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: ax([styles.root, xcss]),
    id: gridRootId,
    "data-testid": testId
  }, children))))));
}